
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getAddOrRemoveDocumentToNewsDtoFormGroup() {
return new FormGroup({
    documentId: new FormControl<number | undefined>(undefined, [Validators.required]),
    moveDocumentToMitteilungenFolder: new FormControl<boolean | undefined>(false),
})
;
}
      